const ITEMS = [
  "Precision Earthworks",
  "Rockhampton · QLD",
  "Heavy Machinery",
  "Site Prep · Bulk Cut",
  "Roadworks · Drainage",
  "Civil Contractors",
];

export default function Marquee() {
  const row = ITEMS.concat(ITEMS);
  return (
    <div
      className="relative border-y border-white/10 bg-black/60 py-6 md:py-8 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {row.map((t, i) => (
          <span
            key={i}
            className="font-display font-black uppercase text-3xl md:text-5xl lg:text-6xl tracking-tight text-white/90 whitespace-nowrap flex items-center px-8"
          >
            {t}
            <span className="ticker-dot" aria-hidden />
          </span>
        ))}
      </div>
    </div>
  );
}
